import React, { useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import CheckImg from "assets/images/check.svg"
import endpoints from "api/endpoints"
import { get } from "api/axios"
import { Link, useParams } from "react-router-dom"
import personPlaceholder from "assets/images/personPlaceholder.png"
import Placeholders from "pages/Home/components/Placeholders"
export default function TheDockies() {
  const { id } = useParams()
  const [users, setUsers] = useState([])
  const [videoCounts, setVideoCounts] = useState({})
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [filter, setFilter] = useState({
    action: "lastMonth",
    text: "Last Month",
  })

  const toggle = () => setDropdownOpen(prevState => !prevState)

  // Fetch award-winning users
  const getFetch = async () => {
    try {
      const resp = await get(
        `${endpoints.getVideos}/winner/count?filter=${filter?.action}`
      )
      if (resp?.data?.success) {
        setUsers(resp?.data?.data)
      }
    } catch (e) {
      console.error(e)
    }
  }

  // Fetch videos count for each user
  const getVideoCountForUser = async userId => {
    try {
      const resp = await get(
        `${endpoints.getVideos}/my/${userId}?page=1&limit=5&filter=ACTIVE`
      )
      if (resp?.data?.success) {
        setVideoCounts(prevCounts => ({
          ...prevCounts,
          [userId]: resp?.data?.totalCount || resp?.data?.count || 0, // Store count in state
        }))
      }
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    getFetch()
  }, [filter])

  useEffect(() => {
    if (users.length > 0) {
      users.forEach(user => getVideoCountForUser(user._id))
    }
  }, [users])

  return (
    <section id="user-profile" className="px-2 px-lg-3 py-2 py-lg-4">
      <div className="vh-75 px-2 px-lg-5 py-2" style={{ minHeight: "60vh" }}>
        <h2 className="ff-cooper text-uppercase font-size-56 fw-normal blue-text-color  pt-3 text-uppercase d-flex justify-content-between">
          The Dockie Awards
          <Dropdown isOpen={dropdownOpen} toggle={toggle} direction={"down"}>
            <DropdownToggle
              caret
              className="d-flex justify-content-between align-items-center filter-btn ff-proxima"
            >
              <span>{filter.text}</span>
              <img src={CheckImg} className="px-2" alt="Check Icon" />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                onClick={() =>
                  setFilter({ action: "lastMonth", text: "Last 30 Days" })
                }
              >
                Last 30 Days
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  setFilter({ action: "threeMonth", text: "Last Three Month" })
                }
              >
                Last Three Month
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  setFilter({ action: "lastYear", text: "Last Year" })
                }
              >
                Last Year
              </DropdownItem>
              <DropdownItem
                onClick={() => setFilter({ action: "active", text: "Older" })}
              >
                Older
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </h2>

        <Row className="col-sm-center pb-5 pb-sm-0">
          {users?.length > 0 &&
            users.map(user => (
              <Col
                key={user._id}
                xs="6"
                sm="4"
                md="3"
                xl="2"
                className="my-2 gap-2"
              >
                <Link to={`/userprofile/${user?._id}`}>
                  <img
                    className="rounded-4 object-fit-cover dockie-class ff-proxima"
                    referrerPolicy="no-referrer"
                    src={
                      user?.profileImage
                        ? user?.profileImage.includes("googleusercontent")
                          ? user?.profileImage
                          : process.env.REACT_APP_S3_BUCKET + user?.profileImage
                        : personPlaceholder
                    }
                    alt="Header Avatar"
                  />
                  <h3 className="d-block text-uppercase fw-medium font-size-18 ff-proxima black-text-color pb-0 mb-0 pt-3">
                    {user.firstName} {user.lastName}
                  </h3>
                </Link>
                <span className="d-block ff-proxima fw-normal font-size-14 text-secondary pt-1">
                  {user.awardCount} awards win
                </span>
                <span className="d-block ff-proxima fw-normal font-size-14 text-secondary pt-1">
                  {videoCounts[user._id] || 0} videos posted{" "}
                  {/* Display video count */}
                </span>
              </Col>
            ))}
        </Row>
        <Row>{users.length <= 0 && <Placeholders />}</Row>
      </div>
    </section>
  )
}
